import React from 'react';
import { Box } from '@mui/material';
import { TabbedOverviewPage, SectionHeader } from '../components/OverviewSections.comp';
import { ScoringBandCards, RiskRubricTable } from '../../DashboardCommon/AssessmentScoring.comp';

/* How the COS Assessment Is Scored — a common slide, static front-end text
   from Ian's Common Section deck (16 Sep), DB-CS-P0,P1-All-AssessmentRubric:
   p.16 (the four scoring rubrics) and p.17 (the risk rubric). The same content
   as the School and Network dashboards' Methodology pages
   (DashboardCommon/AssessmentScoring). It used to read PD section S_18, which
   the Data Map does not list for the Partner dashboard, so the page showed
   only its title. */
const AssessmentScoringSection = () => (
    <Box sx={{pb: 4}}>
        <SectionHeader
            title="How the COS Assessment Is Scored"
            subtitle="What was measured, and how should it be interpreted?"
        />
        <ScoringBandCards/>
        <RiskRubricTable/>
    </Box>
);

const MethodologyPage = () => (
    <TabbedOverviewPage
        skipNoDataGate
        tabs={[
            {
                label: 'How the Assessment Is Scored',
                content: <AssessmentScoringSection/>,
            },
        ]}
    />
);

export default MethodologyPage;
